import { IfpApplicationState } from '@shared/sec-loans'
import { IntlShape } from 'react-intl'

export const getIfpAfterCareTranslations = ({
  formatMessage,
  numDebtors,
  state,
}: {
  formatMessage: IntlShape['formatMessage']
  numDebtors: number
  state: IfpApplicationState
}): { header: string; content: string[]; details?: { header: string; content: string } } => {
  switch (state) {
    case IfpApplicationState.Accepted: {
      return {
        header: formatMessage({ id: 'common-thanks-for-the-application' }),
        content: [
          formatMessage({ id: 'ifp-after-care-approved-content-1' }),
          formatMessage({ id: 'ifp-after-care-approved-content-2' }),
        ],
      }
    }

    case IfpApplicationState.WaitingForCoDebtor: {
      if (numDebtors > 2) {
        return {
          header: formatMessage({ id: 'ifp-after-care-waiting-for-many-co-debtors-header' }),
          content: [formatMessage({ id: 'ifp-after-care-waiting-for-many-co-debtors-content' })],
          details: {
            header: formatMessage({ id: 'ifp-after-care-waiting-for-many-co-debtors-details-header' }),
            content: formatMessage({ id: 'ifp-after-care-waiting-for-many-co-debtors-details-content' }),
          },
        }
      } else {
        return {
          header: formatMessage({ id: 'ifp-after-care-waiting-for-co-debtor-header' }),
          content: [formatMessage({ id: 'ifp-after-care-waiting-for-co-debtor-content' })],
          details: {
            header: formatMessage({ id: 'ifp-after-care-waiting-for-co-debtor-details-header' }),
            content: formatMessage({ id: 'ifp-after-care-waiting-for-co-debtor-details-content' }),
          },
        }
      }
    }

    case IfpApplicationState.Pending:
    default: {
      return {
        header: formatMessage({ id: 'common-thanks-for-the-application' }),
        content: [
          formatMessage({ id: 'ifp-after-care-manual-handling-content-1' }),
          formatMessage({ id: 'ifp-after-care-manual-handling-content-2' }),
          formatMessage({ id: 'ifp-after-care-manual-handling-content-3' }),
        ],
      }
    }
  }
}
